import Day from '@assets/icons/weather/day.svg';
import Rain from '@assets/icons/weather/rain.svg';
import Snow from '@assets/icons/weather/snow.svg';
import Windy from '@assets/icons/weather/windy.svg';
import Night from '@assets/icons/weather/night.svg';
import Cloudy from '@assets/icons/weather/cloudy.svg';
import PartlySunny from '@assets/icons/weather/partly-sunny.svg';

export const WEATHER_ICONS: Record<string, any> = {
    rain: Rain,
    snow: Snow,
    sleet: Snow,
    cloudy: Cloudy,
    fog: Cloudy,
    wind: Windy,
    'clear-day': Day,
    'clear-night': Night,
    'partly-cloudy-night': Night,
    'partly-cloudy-day': PartlySunny,
};

export const EXTERNAL_LINK_PROPS = {
    rel: 'noopener noreferrer',
    target: '_blank',
};

export const EMPTY_VALUE = '--';
